<template>
  <div class="default-navbar">
    <nav class="navbar navbar-expand-lg navbar-light">
      <div class="container">
        <router-link :to="{name: 'Home'}" v-slot="{ href }">
          <a class="navbar-brand" :href="href">
            <!-- Navbar -->
            <img class="logo" src="../assets/logo.svg" alt="logo" />
          </a>
        </router-link>
        <button
          class="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarText"
          aria-controls="navbarText"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarText">
          <ul class="navbar-nav ml-auto">
            <router-link :to="{name: 'Home'}" v-slot="{ href, route, navigate, isActive }">
              <li class="nav-item" :class="{'active': isActive}">
                <a class="nav-link" :href="href">{{$t("home.bnt_home")}}</a>
              </li>
            </router-link>
            <router-link :to="{name: 'BrowseLayout'}" v-slot="{ href, route, navigate, isActive }">
              <li class="nav-item" :class="{'active': isActive}">
                <a class="nav-link" :href="href">{{$t("home.btn_browse")}}</a>
              </li>
            </router-link>
            <!-- <router-link :to="{name: 'NewProvider'}" v-slot="{ href, route, navigate, isActive }">
              <li class="nav-item" :class="{'active': isActive}">
                <a class="nav-link" :href="href">{{$t("home.btn_be_a_provider")}}</a>
              </li>
            </router-link> -->
            <li class="nav-item languages" >
              <div class="row d-flex ml-2">
                <div class="col en d-flex"><span class="nav-link text-right ml-1" v-on:click="clickToEn" v-bind:class="{ 'active': isActiveEN }">{{$t("home.btn_english")}}  </span><span class="nav-link" v-on:click="clickToVi" v-bind:class="{ 'active': isActiveVI }"><span class="yelow">|</span> {{$t("home.btn_vietnamese")}}</span></div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
export default {
  name: "HelloWorld",
  props: {
    msg: String
  },
  data() {
    return {
      isActivie: true,
      isActiveEN: true,
      isActiveVI: false
    };
  },
  methods: {
    clickToEn() {
      this.changeLangueEN();
      window.location.reload();
    },
    clickToVi() {
      this.changeLangueVi();
      window.location.reload();
    },
    changeLangueEN() {
      console.log("en");
      this.$i18n.locale = "en";
      this.isActiveEN = true;
      this.isActiveVI = false;
      localStorage && (localStorage.language = "en");
    },
    changeLangueVi() {
      console.log("vi");
      this.$i18n.locale = "vi";
      this.isActiveEN = false;
      this.isActiveVI = true;
      localStorage && (localStorage.language = "vi");
    },
    changeLang(lang) {
      if (lang == "vi") {
        return this.changeLangueVi();
      }
      return this.changeLangueEN();
    }
  },
  async mounted() {
    if (localStorage && localStorage.language) {
      return this.changeLang(localStorage.language);
    }
    // const userLang = navigator.language || navigator.userLanguage;
    const userLang = "vi";
    console.log("The language is: " + userLang);

    if (userLang.includes("vi")) {
      return this.changeLangueVi();
    }
    return this.changeLangueEN();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.default-footer {
  background-color: red;
}
.navbar-brand > .logo {
  height: 40px;
}

.nav-item {
  .nav-link {
    font-weight: 400;
    padding-left: 25px;
    // padding-right: 20px;
  }
  &.active {
    .nav-link {
      font-weight: bold;
    }
  }
}
.yelow {
  color: #ffbe17;
}
.nav-item .nav-link .languages {
  padding-left: 0px !important;
}
.en .nav-link {
  padding-left: 0px;
  padding-right: 0.3em;
}
.languages {
  cursor: pointer;
  .active {
    font-weight: bold;
  }
}
</style>
